import { render, staticRenderFns } from "./PWReset.vue?vue&type=template&id=59232da8&scoped=true"
import script from "./PWReset.vue?vue&type=script&lang=js"
export * from "./PWReset.vue?vue&type=script&lang=js"
import style0 from "./PWReset.vue?vue&type=style&index=0&id=59232da8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59232da8",
  null
  
)

export default component.exports